export default {
  methods: {

    checkStocks () {
      const warehouseCode = this.user.location_code

      if (!warehouseCode) {
        return this.swalInvalid()
      }

      const productCodes = this.$refs.componentProducts.getFinalProducts().map(
        detail => detail.product_code
      )

      this.getStocks(this, warehouseCode, productCodes).finally(() => {
        this.$refs.componentProducts.setStocksOfProducts(this.options.stocks)
      })

      this.$root.$emit('bv::hide::tooltip')
    },

    createRequest () {
      this.editing = false

      this.editAsDraft = true

      this.stockRequest = Object.assign(this.stockRequest, {
        id: '',
        stage: 0,
        references: {
          document_number: '',
          transfer_number: '',
          sap_doc_entry: '',
          transaction_number: ''
        },
        headers: {
          withdrawal_type: '',
          destination: '',
          destination_name: '',
          destination_code: '',
          supplier: '',
          supplier_name: '',
          supplier_code: ''
        },
        pickup_details: {
          date: '',
          vehicle: '',
          vehicle_plate: '',
          vehicle_name: '',
          driver: '',
          driver_name: '',
          mobile_number: '',
          logistics_type: 'In-House',
          is_3pl: 0,
          helper: ''
        },
        details: Array.from({ length: 5 }).map(
          () => ({
            product: null,
            quantity: null,
            onhand_quantity: 0
          })
        ),
        remarks: ''
      })

      this.getProducts(this).finally(() => {
        this.getDrivers(this)
        this.getVehicles(this)
      })

      this.$bvModal.show('modalRequest')
    },

    submitRequest (remarks = '') {
      const { id, headers, pickup_details } = this.stockRequest
      return this.$refs.srPending.create({
        id: id,
        withdrawal_type: headers.withdrawal_type,
        destination: headers.destination,
        supplier: headers.supplier,
        remarks: remarks,
        pickup_details: {
          date: pickup_details.date,
          vehicle: pickup_details.vehicle,
          vehicle_plate: pickup_details.vehicle_plate,
          vehicle_name: pickup_details.vehicle_name,
          driver: pickup_details.driver,
          driver_name: pickup_details.driver_name,
          mobile_number: pickup_details.mobile_number,
          is_3pl: pickup_details.is_3pl,
          helper: pickup_details.helper
        },
        details: this.$refs.componentProducts.getFinalProducts(),
        active: 1
      }).then(() => {
        this.currentTabIndex = 0
      }).catch(
        errors => {
          if (errors.errors) {
            if (this.$refs.formStockRequest) {
              this.$refs.formStockRequest.setErrors({
                'headers.destination': errors.errors?.destination || [],
                'headers.category': errors.errors?.category || []
              })
            }

            this.setProductErrors(errors.errors)
            this.$refs.formWithdrawal.setErrors(errors.errors)
          }
        }
      )
    }
  }
}
